import { BDO, LooseOrderSubtype, OrderType, PaymentType, PriceType } from 'types';

export interface ClientOrder {
	id: number;
	type: OrderType;
	subtype: 'delivery' | LooseOrderSubtype;
	wasReplacement: boolean;
	onPlace: boolean;
	bdo: BDO;
	wasteType: string;
	date: string;
	doneDate: string | undefined;
	address: string;
	containerId: number | undefined;
	netPrice: number;
	grossPrice: number;
	priceType: PriceType;
	wantedPaymentType: PaymentType;
	paid: number;
	invoiceDate: string | undefined;
}
